/** @deprecated Use the type instead. */
export const MAP_SETTINGS_KEYS = {
  DATA_VIEW_POLYGON_OPACITY: 'map.polygon.opacity',
  PIE_CHART_SIZE: 'map.pieChart.size',
  PIE_CHART_SIZE_DEFAULT: 'map.pieChart.size.default',
  PIE_CHART_VALUE_LABELS: 'map.pieChart.valueLabels',
  PIE_CHART_VALUE_LABELS_DEFAULT: 'map.pieChart.valueLabels.default',
  PIE_CHART_SHOW_TOTALS: 'map.pieChart.showTotals',
  PIE_CHART_SHOW_TOTALS_DEFAULT: 'map.pieChart.showTotals.default',
  HEATMAP_RADIUS_VALUE: 'map.heatmap.radius.value',
  HEATMAP_RADIUS_VALUE_DEFAULT: 'map.heatmap.radius.value.default',
  HEATMAP_RADIUS_UNIT: 'map.heatmap.radius.unit',
  HEATMAP_RADIUS_UNIT_DEFAULT: 'map.heatmap.radius.unit.default',
  HEATMAP_GRADIENT: 'map.heatmap.gradient',
  HEATMAP_GRADIENT_DEFAULT: 'map.heatmap.gradient.default',
  HEATMAP_OPACITY: 'map.heatmap.opacity',
  HEATMAP_OPACITY_DEFAULT: 'map.heatmap.opacity.default',
  HEATMAP_GRADIENT_REVERSE: 'map.heatmap.gradient.reverse',
  HEATMAP_GRADIENT_REVERSE_DEFAULT: 'map.heatmap.gradient.reverse.default',
  NUMERIC_CLASSIFICATION_LABEL_MODE: 'map.numericClassification.labelMode',
  NUMERIC_CLASSIFICATION_LABEL_MODE_DEFAULT: 'map.numericClassification.labelMode.default',
  SCALE_RANGE_MIN: 'map.scaleRange.min',
  SCALE_RANGE_MAX: 'map.scaleRange.max'
};

/**
 * Map data view settings keys
 *
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export type MapSettingKey = typeof MAP_SETTINGS_KEYS[keyof typeof MAP_SETTINGS_KEYS];

/**
 * Values for the key MAP_SETTINGS_KEYS.PIE_CHART_SIZE.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartSize.java
 */
export const PIE_CHART_SIZE = {
  CONSTANT: 'constant',
  PROPORTIONAL: 'proportional'
};

/**
 * Values for the key MAP_SETTINGS_KEYS.PIE_CHART_VALUE_LABELS.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartValueLabels.java
 */
export const PIE_CHART_VALUE_LABELS = {
  NONE: 'none',
  VALUE: 'value',
  PERCENTAGE: 'percentage'
};

/**
 * Values for the key MAP_SETTINGS_KEYS.HEATMAP_RADIUS_UNIT.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/HeatmapRadiusUnits.java
 */
export const HEATMAP_RADIUS_UNITS = [
  'kilometers',
  'meters',
  'pixels'
];
